import axios from 'axios';
import { DATABASE_URL, STUDIO_API_TOKEN } from '../../constants';
import appMode from '../../services/appMode';

let _masterAxios = null;
let _masterAxiosToken = null;

function getMasterAxios() {
    // Prefer the token injected by the app via ?arkaToken= URL param,
    // fall back to the hardcoded service token for web/dev use.
    const token = appMode.getAuthToken() || STUDIO_API_TOKEN;

    // Rebuild the instance if the token changed (e.g. first call before appMode initialised)
    if (_masterAxios && _masterAxiosToken === token) return _masterAxios;

    _masterAxiosToken = token;
    // In dev the Vite proxy rewrites /api/master-data → devapi.arka360.com, so
    // we use an empty baseURL (relative) to avoid CORS from localhost.
    // In production the portal is served from the same domain and needs the full URL.
    const baseURL = import.meta.env.DEV ? '' : DATABASE_URL;
    _masterAxios = axios.create({
        baseURL,
        headers: {
            'accept': 'application/json',
            'content-type': 'application/json',
            'authorization': token.startsWith('Token ') ? token : `Token ${token}`,
        },
    });
    return _masterAxios;
}

export default {
    FETCH_MASTER_PANELS() {
        return getMasterAxios().get('/api/master-data/modules/', { params: { old: true } });
    },
    SEARCH_MASTER_PANELS(query) {
        return getMasterAxios().get('/api/master-data/modules/', { params: { old: true, ...query } });
    },
    FETCH_MASTER_INVERTERS() {
        return getMasterAxios().get('/api/master-data/master-inverters/', { params: { all_inverter: true } });
    },
    SEARCH_MASTER_INVERTERS(query) {
        return getMasterAxios().get('/api/master-data/master-inverters/', { params: { all_inverter: true, ...query } });
    },
    LOAD_NEXT(url) {
        return getMasterAxios().get(url);
    },
};
